const general = {
  action: {
    select: 'Selecionar',
    returnToHome: 'Ir para Início',
    uploadTitle: 'Adicionar documento assinado',
    uploadDescription: 'Arraste e solte aqui ou clique para selecionar',
  },
  feature: {
    attention: 'Atenção',
    beta: 'Beta',
    test_beta_features: 'Teste novos recursos antes deles serem lançados oficialmente.',
    unavailable_in_your_plan: 'Funcionalidade não inclusa em seu plano',
    more_info: 'Saiba mais.',
  },
  errors: {
    restrictedFile: 'O documento possui senha, não foi possivel validar',
    unexpected: 'Ocorreu um erro inesperado',
    invalidFile: 'Arquivo inválido',
  },
};

export default general;
